import { useState, useRef, useEffect } from 'react';

import styles from './Carousel.module.css';

export default function CarouselComponent(props) {

    const xScrollContainerRef = useRef(null);
    const rightArrowRef = useRef(null);

    const [isDisabledLeftArrow, setIsDisabledLeftArrow] = useState(true);
    const [isDisabledRightArrow, setIsDisabledRightArrow] = useState(false);

    const onScrollEnded = () => {
        setIsDisabledLeftArrow(false);
        setIsDisabledRightArrow(false);

        if (0 === xScrollContainerRef.current.scrollLeft) {
            setIsDisabledLeftArrow(true);
        }
        if (xScrollContainerRef.current.scrollWidth <= (Math.floor(xScrollContainerRef.current.scrollLeft + xScrollContainerRef.current.offsetWidth) + 5)) {
            setIsDisabledRightArrow(true);
        }
    }

    useEffect(() => {
        const refCurrent = xScrollContainerRef.current;
        xScrollContainerRef.current?.addEventListener('scrollend', onScrollEnded);
        return () => refCurrent?.removeEventListener('scrollend', onScrollEnded);
    }, []);


    const toLeft = (e) => {
        e.stopPropagation();

        const size = xScrollContainerRef.current.offsetWidth;
        xScrollContainerRef.current.scrollBy({
            top: 0,
            left: -(size - (size / 10)),
            behavior: 'smooth'
        });

        setTimeout(() => {
            if (0 === xScrollContainerRef.current.scrollLeft) {
                setIsDisabledLeftArrow(true);
            }
            setIsDisabledRightArrow(false);
        }, 1000);
    }

    const toRight = (e) => {
        e.stopPropagation();

        const size = xScrollContainerRef.current.offsetWidth;

        xScrollContainerRef.current.scrollBy({
            top: 0,
            left: +(size - (size / 10)),
            behavior: 'smooth'
        });

        // setTimeout(() => {
        //     try {
        //         console.log(xScrollContainerRef.current.scrollWidth);
        //         console.log((Math.floor(xScrollContainerRef.current.scrollLeft + xScrollContainerRef.current.offsetWidth)+5));

        //         if (xScrollContainerRef.current.scrollWidth <= (Math.floor(xScrollContainerRef.current.scrollLeft + xScrollContainerRef.current.offsetWidth)+5)) {
        //             setIsDisabledRightArrow(true);
        //         }
        //         setIsDisabledLeftArrow(false);
        //     } catch (error) {
        //         console.log(error);
        //     }
        // }, 1000);
    }



    return (
        <div className={styles.carouselContainer}>
            <div className={styles.roundArrows}>
                <button ref={rightArrowRef} onClick={toLeft} disabled={isDisabledLeftArrow}>
                    <svg className={styles.arrowLeft} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25 15C25 9.4875 20.5125 5 15 5C9.4875 5 5 9.4875 5 15C5 20.5125 9.4875 25 15 25C20.5125 25 25 20.5125 25 15ZM27.5 15C27.5 21.9 21.9 27.5 15 27.5C8.1 27.5 2.5 21.9 2.5 15C2.5 8.1 8.1 2.5 15 2.5C21.9 2.5 27.5 8.1 27.5 15ZM11.25 15L16.25 20V10L11.25 15Z" fill="currentColor" />
                    </svg>
                </button>
                <button onClick={toRight} disabled={isDisabledRightArrow}>
                    <svg className={styles.arrowRight} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 15C5 9.4875 9.4875 5 15 5C20.5125 5 25 9.4875 25 15C25 20.5125 20.5125 25 15 25C9.4875 25 5 20.5125 5 15ZM2.5 15C2.5 21.9 8.1 27.5 15 27.5C21.9 27.5 27.5 21.9 27.5 15C27.5 8.1 21.9 2.5 15 2.5C8.1 2.5 2.5 8.1 2.5 15ZM18.75 15L13.75 20L13.75 10L18.75 15Z" fill="currentColor" />
                    </svg>
                </button>
            </div>
            <div ref={xScrollContainerRef} className={styles.screenshotsContainer}>
                {props.thumbnailImages?.map(
                    (item, index) => {
                        let animation =
                            " animate__animated animate__fadeInRight animate__slow ";

                        switch (index) {
                            case 0:
                                animation += "";
                                break;
                            case 1:
                                animation += "animate__delay-1s";
                                break;
                            case 2:
                                animation += "animate__delay-2s";
                                break;
                            case 3:
                                animation += "animate__delay-3s";
                                break;
                            case 4:
                                animation += "animate__delay-4s";
                                break;
                            default:
                                animation += "animate__delay-5s";
                                break;
                        }

                        return (
                            <picture key={item.id} className={animation + ' ' + (props.isSmallSize ? styles.small_screenshot : styles.screenshot)}>
                                <source type="image/webp" media="(min-width:750px)" srcSet={item.image1x + ' 1x, ' + item.image2x + ' 2x'} alt={item.alt} />
                                <source type="image/webp" media="(min-width:300px)" srcSet={item.imageM1x + ' 1x, ' + item.imageM2x + ' 2x'} alt={item.alt} />
                                <img src={item.image1x} alt={item.alt} />
                            </picture>
                        );
                    }
                )}

            </div>
        </div>
    );
}
